import React, { useContext } from "react";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./Components/Login/Login";
import Dashboard from "./Components/Dashboard/Dashboard";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";
import Compra from "./Components/Compra/Compra";
import Saque from "./Components/Saque/Saque";
import ProfilePage from "./Components/UserPage/UserPage";
import Noticias from "./Components/Noticias/Noticias";
import Extrato from "./Components/Extrato/Extrato";
import PulseAnimation from "./Components/Loading/Pulse";
import CadastroPage from "./Components/Cadastro/CadastroPage";
import { LoadProvider } from "./context/LoadContext";
import assets from "./assets/assets";
import useImagePreloader from "./hooks/useImagePreloader";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import ForgotPasswordUsername from "./Components/ForgotPassword/ForgotPasswordUsername";
import AlterarSenha from "./Components/AlterarSenha/AlterarSenha";
import { createGlobalStyle } from "styled-components";
import NovoRelatorio from "./Components/Relatorio/NovoRelatorio";
import ExtratoValorizacao from "./Components/ExtratoValorizacao/ExtratoValorizacao";
import RegisterIncompleted from "./Components/RegisterIncompleted/RegisterIncompleted";
import { MessageProvider } from "./context/MessageContext";
import PaginaSaque from "./Components/PaginaSaque/PaginaSaque";
import ContaDeposito from "./Components/ContaDeposito/ContaDeposito";
import PaginaContrato from "./Components/PaginaContrato/PaginaContrato";
import PremiumLoadingScreen from "./Components/PremiumLoading/PremiumLoading";
import EditPass from "./Components/EditPass/EditPass";
import TokenLogin from "./Components/TokenLogin/TokenLogin"; // Importa o novo componente
import Caixinha from "./Components/Caixinha/Caixinha";
import VincularConsultor from "./Components/VincularConsultor/VincularConsultor";

const GlobalStyle = createGlobalStyle`
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: linear-gradient(to bottom, #d7dbe0, #c5cdd6, #b3bec9);
    border-radius: 0px;
  }
`;

function AppContent() {
  useImagePreloader(Object.values(assets));
  const {
    isLoading,
    isAuthenticated,
    isDataLoaded,
    loadingProgress,
    loadingMessage,
  } = useContext(AuthContext);

  if (isLoading && isAuthenticated) {
    return (
      <PremiumLoadingScreen
        isLoading={isLoading}
        isDataLoaded={isDataLoaded}
        progress={loadingProgress}
        message={loadingMessage}
      />
    );
  }

  return (
    <>
      <PulseAnimation />
      <GlobalStyle />
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/token-login" element={<TokenLogin />} />
          <Route path="/cadastro" element={<CadastroPage />} />
          <Route path="/recover" element={<ForgotPassword />} />
          <Route path="/vincular" element={<VincularConsultor />} />
          <Route path="/redefine-password" element={<EditPass />} />
          
          <Route
            path="/recoverByUsername"
            element={<ForgotPasswordUsername />}
          />
          <Route
            path="/dashboard"
            element={<PrivateRoute element={Dashboard} />}
          />
          <Route
            path="/novacompra"
            element={<PrivateRoute element={Compra} />}
          />
          <Route path="/saque" element={<PrivateRoute element={Saque} />} />
          <Route
            path="/saques/:saqueId"
            element={<PrivateRoute element={PaginaSaque} />}
          />
          <Route
            path="/contratos/:contratoId"
            element={<PrivateRoute element={PaginaContrato} />}
          />
          <Route
            path="/user"
            element={<PrivateRoute element={ProfilePage} />}
          />
          <Route
            path="/noticias"
            element={<PrivateRoute element={Noticias} />}
          />
          <Route path="/extrato" element={<PrivateRoute element={Extrato} />} />
          <Route
            path="/extratovalorizacao"
            element={<PrivateRoute element={ExtratoValorizacao} />}
          />
          <Route
            path="/relatorio"
            element={<PrivateRoute element={NovoRelatorio} />}
          />
          <Route path="/alterarSenha" element={<AlterarSenha />} />
          <Route path="/ContaDeDeposito" element={<ContaDeposito />} />
          <Route path="/completeRegister" element={<RegisterIncompleted />} />
          <Route
            path="/caixinha"
            element={<PrivateRoute element={Caixinha} />}
          />
        </Routes>
      </Router>
    </>
  );
}

function App() {
  return (
    <LoadProvider>
      <MessageProvider>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </MessageProvider>
    </LoadProvider>
  );
}

export default App;
